import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-gerund-color" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainNavbar = _resolveComponent("MainNavbar")!
  const _component_ServicesDetails4 = _resolveComponent("ServicesDetails4")!
  const _component_AwardWinningAgency = _resolveComponent("AwardWinningAgency")!
  const _component_IncreaseYourBrands = _resolveComponent("IncreaseYourBrands")!
  const _component_TestimonialsContent = _resolveComponent("TestimonialsContent")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainNavbar, {
      class: "bg-transparent fixed-top border-bottom",
      mwClass: "",
      className: "m-auto"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_ServicesDetails4),
      _createVNode(_component_AwardWinningAgency),
      _createVNode(_component_IncreaseYourBrands, {
        class: "pt-100",
        className: "border-style pb-100"
      }),
      _createVNode(_component_TestimonialsContent)
    ]),
    _createVNode(_component_MainFooter)
  ], 64))
}